import { MatDialogConfig } from '@angular/material/dialog';

export const matDialogDefaultConfig: MatDialogConfig = {
  minHeight: '26rem',
  width: '64rem',
  maxWidth: '90vw',
  maxHeight: '90vh',
  hasBackdrop: true,
};